<template>
	<div>
		<Loading v-if="loading" />
		<div class="action-list">
			<div class="filter-box">
				<h5>فیلترها</h5>
				<div class="inputs-container">
					<ComponentInput ref="mobileInput" inputType="text" label="شماره موبایل:"
						@textChange="handleTextChange" />
					<ComponentInput ref="mobileInput" inputType="text" label="کد ملی:" @textChange="handleCodeChange" />
					<div class="date-filter">
						<label for="html">تاریخ :</label>
						<input id="date" type="text" class="custom-input inputs" />
						<date-picker v-model="rangeDate" range clearable format="YYYY-MM-DDTHH:mm:00"
							display-format="jMMMM jD" custom-input="#date" />
					</div>

					<CustomSelect :label="'شغل:'" :options="jobOptions" :nameFeild="'name_fa'"
						@selectChange="handleJobSelectChange" class="mr-2" />
				</div>
				<div class="d-flex justify-content-end w-100">
					<PrimaryButton :backgroundColor="'#C64925'" @click="getData">تایید</PrimaryButton>
					<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2" @click="removeFilter">
						حذف فیلتر</PrimaryButton>
				</div>
			</div>
			<div class="box">
				<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
				<Tableview :hover="true" :bordered="true"
					:showNoContent="bankCreditChargeList && !bankCreditChargeList.length">
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>شماره موبایل</th>
							<th>کد ملی</th>
							<th>نام و نام خانوادگی</th>
							<th>فروشگاه</th>
							<th>مبلغ وام درخواستی</th>
							<th>شناسه پرونده</th>
							<th>شناسه درخواست</th>
							<th>تامین کننده</th>
							<th>تاریخ ایجاد پرونده</th>
							<th>تاریخ آخرین ویرایش</th>
							<th>دلیل دریافتی</th>
							<th>وضعیت پرونده</th>
							<th>پشتیبان</th>
							<th>عملیات</th>
							<th></th>
							<th></th>
						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in bankCreditChargeList" :key="item.id" :class="{ 'selected-row': item.id === selectedID }">
							<td class="persian-number">
								{{ 20 * (page - 1) + 1 + index }}
							</td>
							<td class="persian-number">{{ item.gb_user.user.username }}</td>
							<td class="persian-number">
								{{ item.gb_user.national_code }}
							</td>
							<td>{{ item.gb_user.first_name }} {{ item.gb_user.last_name }}</td>
							<td>
								<span v-if="item.store" @click="storeHandler(item)" class="store-link">{{ item.store }}</span>
								<span v-else>-</span>
							</td>
							<td>{{ item.loan_payment_plan.loan_plan.amount_separate }} ریال</td>
							<td class="persian-number">
								{{ item.loan_cases && item.loan_cases[0] ? item.loan_cases[0].id : '-' }}
							</td>
							<td class="persian-number">
								{{ item.loan_cases && item.loan_cases[0] ? item.loan_cases[0].loan_request : '-' }}
							</td>
							<td>
								{{ item.loan_payment_plan.loan_plan.provider.name_fa }}
							</td>
							<td>
								<date-picker v-if="item.loan_cases && item.loan_cases[0]"
									v-model="item.date_time_create" type="datetime" format="YYYY-MM-DD"
									display-format="jYYYY-jMM-jDD" :timezone="true" :disabled="true" />
								<span v-else>-</span>
							</td>
							<td>
								<date-picker v-if="item.loan_cases && item.loan_cases[0]"
									v-model="item.date_time_last_change" type="datetime"
									format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" :timezone="true"
									:disabled="true" />
								<span v-else>-</span>
							</td>
							<td v-html="item.loan_cases && item.reason ? item.reason : '-'"></td>
							<td>
								{{ item.loan_status.verbose_name }}
							</td>
							<td>
								{{ item.call_center_gb_user ? item.call_center_gb_user.first_name || '-' : '-' }}
								{{ item.call_center_gb_user ? item.call_center_gb_user.last_name || '-' : '-' }}
							</td>
							<td>
								<img @click="moreInfoHandler(item)"
									src="../../assets/images/iconPack/user_data_admin.svg" />
							</td>
							<td>
								<img @click="blueUpdateStatus(item.id)"
									src="../../assets/images/iconPack/refresh-white-orange.svg" />
							</td>
							<td>
								<img @click="openBlockUserModal(item)"
									src="../../assets/images/iconPack/lock.svg" class="icon-red" />
							</td>
						</tr>
					</template>
				</Tableview>
				<b-modal v-model="moreInfoModal" hide-footer hide-header centered size="xl">
					<div class="px-4">
						<div class="loan-info-form">
							<h6 class="mb-3">اطلاعات کاربر</h6>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>نام:</label>
									<input v-model="formData.gbUser.first_name" />
								</div>
								<div class="form-group col-md-4">
									<label>نام خانوادگی:</label>
									<input v-model="formData.gbUser.last_name" />
								</div>
								<div class="form-group col-md-4">
									<label>کد ملی:</label>
									<input v-model="formData.gbUser.national_code" />
								</div>
								<div class="form-group col-md-4">
									<label>تاریخ تولد:</label>
									<input disabled v-model="formData.gbUser.birth_date_fa" />
								</div>
								<div class="form-group col-md-4">
									<label>شغل:</label>
									<input v-model="formData.gbUser.job" />
								</div>
								<div class="form-group col-md-4">
									<label>سمت شغلی:</label>
									<select v-model="formData.gbUser.job_role" class="form-control">
										<option value="">انتخاب کنید</option>
										<option v-for="role in jobRoles" :key="role.value" :value="role.value">
											{{ role.label }}
										</option>
									</select>
								</div>
								<div class="form-group col-md-4">
									<label>شماره تلفن ثابت:</label>

								</div>
								<div class="form-group col-md-4">
									<label>کد پستی:</label>
									<input v-model="formData.gbUser.postal_code" />
								</div>

								<div class="form-group col-md-4">
									<label>نوع مالکیت منزل:</label>
									<select v-model="formData.gbUser.house_ownership" class="form-control">
										<option value="">انتخاب کنید</option>
										<option v-for="option in ownershipOptions" :key="option.value"
											:value="option.value">
											{{ option.label }}
										</option>
									</select>
								</div>
								<div class="form-group col-md-4">
									<label>میانگین درآمد:</label>
									<input v-model="formData.gbUser.income_avg" />
								</div>
								<div class="form-group col-md-4">
									<label>میانگین هزینه:</label>
									<input v-model="formData.gbUser.cost_avg" />
								</div>
								<div class="form-group col-md-4">
									<label>قسط ماهیانه:</label>
									<input v-model="formData.gbUser.monthly_instalment" />
								</div>


							</div>

							<!-- Basic Information -->
							<h6 class="mb-3">اطلاعات پایه</h6>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>شناسه پرونده:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.id_persian : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره درخواست:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.loan_request_persian : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>تاریخ ایجاد:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.date_time_create_fa : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>وضعیت پرونده:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.case_status : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره چک:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.cheque_number : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره سریال چک:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.check_serial_number : '-' }}</p>
								</div>
							</div>



							<!-- Documents -->
							<div class="documents-section mt-4">
								<h6 class="mb-3">مدارک</h6>
								<div class="document-links">
									<div class="form-row mb-5">
										<div class="col-md-4" v-if="selectedLoanCase && selectedLoanCase.contract_link">
											<div class="document-card">
												<a :href="selectedLoanCase.contract_link" target="_blank"
													class="doc-link">
													<span>دانلود قرارداد</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.check_image_link">
											<div class="document-card">
												<a :href="selectedLoanCase.check_image_link" target="_blank"
													class="doc-link">
													<span>دانلود تصویر چک</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.income_account_print_link">
											<div class="document-card">
												<a :href="selectedLoanCase.income_account_print_link" target="_blank"
													class="doc-link">
													<span>دانلود صورت حساب</span>
												</a>
											</div>
											<div class="w-100 d-flex justify-content-center"
												style="cursor: pointer; text-decoration: underline; color: #c64925"
												@click="uploadFile('income_account_print')">
												بارگذاری مجدد
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.income_cheque_link">
											<div class="document-card">
												<a :href="selectedLoanCase.income_cheque_link" target="_blank"
													class="doc-link">
													<span>دانلود مدرک شغلی/فیش حقوقی</span>
												</a>
											</div>
											<div class="w-100 d-flex justify-content-center"
												style="cursor: pointer; text-decoration: underline; color: #c64925"
												@click="uploadFile('income_cheque')">
												بارگذاری مجدد
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.occupation_proof_link">
											<div class="document-card">
												<a :href="selectedLoanCase.occupation_proof_link" target="_blank"
													class="doc-link">
													<span>دانلود گواهی شغلی</span>
												</a>
											</div>
											<div class="w-100 d-flex justify-content-center"
												style="cursor: pointer; text-decoration: underline; color: #c64925"
												@click="uploadFile('occupation_proof')">
												بارگذاری مجدد
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex justify-content-end">
								<PrimaryButton :loading="acceptLoanLoading" :backgroundColor="'#C64925'"
									@click="acceptLoan">تایید و
									ارسال به بانک</PrimaryButton>
								<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
									@click="editUserInfo">ذخیره
									تغییرات</PrimaryButton>
								<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
									@click="editLoan">درخواست
									اصلاح</PrimaryButton>
								<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
									@click="rejectLoan">بستن
								</PrimaryButton>
							</div>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="blockUserModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">
							مسدود کردن کاربر
							<span v-if="selectedBlockItem"> - {{ selectedBlockItem.gb_user.first_name }} {{ selectedBlockItem.gb_user.last_name }}</span>
						</h5>
						<p class="mb-3">دلیل مسدود کردن را انتخاب کنید</p>
						<p class="mb-2"><strong>دلیل انتخاب‌شده:</strong> لغو وام به درخواست کاربر</p>
						<div class="d-flex justify-content-end mt-3" style="gap: 8px">
							<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
								@click="blockUserModal = false">
								منصرف شدم
							</PrimaryButton>
							<PrimaryButton :backgroundColor="'#C64925'" @click="confirmBlockUser">
								تایید
							</PrimaryButton>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="editLoanModal" hide-footer hide-header centered size="xl">
					<div class="px-4">
						<h5 class="mb-4">ویرایش پرونده</h5>
						<div class="edit-form">
							<div class="form-row">
								<div class="form-group col-md-4" v-for="field in editableFields" :key="field.value">
									<div class="d-flex align-items-center mb-2">
										<input type="checkbox" :value="field.value" v-model="selectedFields"
											class="mr-2" />
										<label>{{ field.label }}</label>
									</div>
								</div>
							</div>

							<CustomSelect :label="'وضعیت:'" :options="stateOptions" :nameFeild="'label'"
								@selectChange="handleStateChange" />
							<CustomSelect :label="'کامنت:'" :options="BackOfficeCommentList" :nameFeild="'title'"
								@selectChange="handleCommentSelectChange" />
							<div class="form-group mt-3 w-50">
								<label class="mb-2">دلیل:</label>
								<vue-editor v-model="correctionReason" placeholder="در این قسمت دلیل خود را وارد کنید"
									:editorOptions="editorOptions" class="rtl-editor" />
							</div>

							<div class="d-flex justify-content-end mt-4">
								<PrimaryButton :backgroundColor="'#C64925'" @click="submitCorrections"
									:loading="submitEditloading" :disabled="disabledSubmit">
									ثبت اصلاحات
								</PrimaryButton>
								<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
									@click="cancelEdit">
									بستن
								</PrimaryButton>
							</div>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="storeModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">اطلاعات فروشگاه</h5>
						<div style="white-space: pre-line;">{{ storeOwnerName }}</div>
						<div style="white-space: pre-line;">{{ storeMobileNumber }}</div>
						<div class="d-flex justify-content-end mt-3">
							<PrimaryButton :backgroundColor="'#C64925'" @click="storeModal = false">
								بستن
							</PrimaryButton>
						</div>
					</div>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';
// import CustomInput from '../../components/InputFilter/customInput.vue';
import CustomSelect from '../../components/InputFilter/customSelect.vue';
import PrimaryButton from '../../components/Button/Btn.vue';
import Loading from '../../components/Loading/index.vue';
import ComponentInput from '../../components/InputFilter/customInput.vue';
import { VueEditor } from 'vue2-editor';

export default {
	components: {
		Tableview,
		Pagination,
		Loading,
		ComponentInput,
		CustomSelect,
		PrimaryButton,
		VueEditor,
	},
	data() {
		return {
			bankCreditChargeList: [],
			totalDataCount: 0,
			page: 1,
			loading: true,
			selectCityOptions: [],
			selectedCityOption: '',
			selectedProvinceOption: '',
			selectProvinceOptions: [],
			computedMobileNumber: '',
			computedNationalCode: '',
			rangeDate: ['', ''],
			selectedState: '',
			jobOptions: [
				{
					id: 'retired',
					name: 'retired',
					name_fa: 'بازنشسته',
				},
				{
					id: 'employee',
					name: 'employee',
					name_fa: 'کارمند',
				},
				{
					id: 'employer/freelancer',
					name: 'employer/freelancer',
					name_fa: 'آزاد',
				},
			],
			jobRoles: [
				{ value: 'employee', label: 'کارمند' },
				{ value: 'employer/freelancer', label: 'شغل آزاد' },
				{ value: 'retired', label: 'بازنشسته' },
				{ value: 'other', label: 'سایر مشاغل' },
			],
			ownershipOptions: [
				{ value: 'rental', label: 'مستاجر' },
				{ value: 'ownership', label: 'مالک' },
			],
			relationOptions: [
				{ value: 'FAMILY', label: 'خانواده' },
				{ value: 'FRIEND', label: 'دوست' },
			],
			selectedCaseStatusOption: '',
			selectedJobOption: '',
			moreInfoModal: false,
			editLoanModal: false,
			payableState: null,
			ids: null,
			selectedLoanCase: null,
			selectedGBUser: null,
			selectedID: null,
			caseStatus: [],
			selectedFields: [],
			correctionReason: '',
			storeModal: false,
			storeOwnerName: null,
			storeMobileNumber:null,
			BackOfficeCommentList: [],
			selectedBackOfficeComment: '',
			editableFields: [
				// { value: 'national_identifier', label: 'کد ملی' },
				{ value: 'birth_date', label: 'تاریخ تولد' },
				// { value: 'residence_address.province', label: 'استان' },
				// { value: 'residence_address.city', label: 'شهر' },
				{ value: 'residence_address.address', label: 'آدرس' },
				{ value: 'residence_address.postal_code', label: 'کد پستی' },
				{ value: 'residency_type', label: 'نوع سکونت' },
				{ value: 'home_phone_number', label: 'تلفن ثابت' },
				{ value: 'income_amount', label: 'میزان درآمد' },
				{ value: 'occupation_type', label: 'نوع شغل' },
				{ value: 'occupation_title', label: 'عنوان شغل' },
				{ value: 'monthly_cost', label: 'هزینه ماهیانه' },
				{ value: 'monthly_installments', label: 'اقساط ماهیانه' },
				{ value: 'income_account_print', label: 'تصویر صورت حساب' },
				{ value: 'income_cheque', label: 'تصویر فیش حقوقی' },
				{ value: 'occupation_proof', label: 'تصویر سایر مدارک' },
			],
			stateOptions: [
				{ id: 'user_need_correction', label: 'نیاز به اصلاح اطلاعات' },
				{ id: 'blocked', label: 'مسدود کردن' },
				// { id: 'admin_confirmed', label: 'تایید ' },
			],
			submitEditloading: false,
			acceptLoanLoading: false,
			editorOptions: {
				placeholder: 'در این قسمت دلیل خود را وارد کنید',
				direction: 'rtl',
			},
			blockUserModal: false,
			selectedBlockItem: null,
			selectedBlockReasonId: '',
			formData: {
				gbUser: {
					first_name: '',
					last_name: '',
					national_code: '',
					birth_date_fa: '',
					job: '',
					job_role: '',
					land_line_phone: '',
					postal_code: '',
					sheba: '',
					house_ownership: '',
					income_avg: '',
					cost_avg: '',
					monthly_instalment: '',
					city: '',
					address: '',
				},
				loanCase: {
					family1_first_name: '',
					family1_last_name: '',
					family1_relation: '',
					family1_national_code: '',
					family1_phone_number: '',
					family2_first_name: '',
					family2_last_name: '',
					family2_relation: '',
					family2_national_code: '',
					family2_phone_number: '',
				},
			},
			changedFiles: {
				income_account_print: false,
				income_cheque: false,
				occupation_proof: false,
			},
			uploadedFiles: {
				income_account_print: { link: null, uuid: null },
				income_cheque: { link: null, uuid: null },
				occupation_proof: { link: null, uuid: null },
			},
		};
	},
	computed: {
		disabledSubmit() {
			if (this.selectedState === 'blocked' && this.correctionReason !== '') {
				return false;
			}

			if (this.selectedFields.length === 0) {
				return true;
			}
			if (this.correctionReason === '') {
				return true;
			}
			return false;
		},
	},
	watch: {
		selectedGBUser: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.formData.gbUser = { ...newVal };
				} else {
					this.formData.gbUser = {
						first_name: '',
						last_name: '',
						national_code: '',
						birth_date_fa: '',
						job: '',
						job_role: '',
						land_line_phone: '',
						postal_code: '',
						sheba: '',
						house_ownership: '',
						income_avg: '',
						cost_avg: '',
						monthly_instalment: '',
						city: '',
						address: '',
					};
				}
			},
		},
		selectedLoanCase: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.formData.loanCase = { ...newVal };
				} else {
					this.formData.loanCase = {
						family1_first_name: '',
						family1_last_name: '',
						family1_relation: '',
						family1_national_code: '',
						family1_phone_number: '',
						family2_first_name: '',
						family2_last_name: '',
						family2_relation: '',
						family2_national_code: '',
						family2_phone_number: '',
					};
				}
			},
		},
	},
	mounted() {
		this.getData();
		this.getCaseStatus();
		this.getBackOfficeComment();
	},
	methods: {
		async getData(limit = 20, offset = 0) {
			if (this.rangeDate[0] !== '' && this.rangeDate[1] == undefined) {
				this.rangeDate[1] = this.rangeDate[0].slice(0, 11) + '23:59:59';
			} else if (this.rangeDate[0] === null || this.rangeDate[0] === undefined) {
				this.rangeDate[0] = '';
			}
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.REQUEST_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset +
				'&gb_user__user__username=' +
				this.computedMobileNumber +
				'&loancase__reason__isnull=' +
				this.haveReason +
				'&gb_user__national_code=' +
				this.computedNationalCode +
				'&gb_user__job_role=' +
				this.selectedJobOption +
				'&loan_status__id=' +
				'26' +
				'&loancase__reason__isnull=' +
				false +
				'&date_time_create__gte=' +
				this.rangeDate[0] +
				'&date_time_create__lte=' +
				this.rangeDate[1] +
				'&ordering=date_time_last_change',
				'',
				{},
			);
			if (res.status === 200) {
				this.bankCreditChargeList = res.data.results;
				this.totalDataCount = res.data.count;
				this.loading = false;
			}
		},
		async getCaseStatus() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.CASE_STATUS + '?provider=3',
				this.$PATH.SERVICE_NAME.LOYALTY,
				{},
			);
			if (res.status === 200) {
				console.log(res.data);
				this.caseStatus = res.data;
			}
		},
		async getBackOfficeComment() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.BackOfficeComment,
				'',
				{},
			);
			if (res.status === 200) {
				console.log(res.data);
				this.BackOfficeCommentList = res.data;
			}
		},
		handleCommentSelectChange(value) {
			this.selectedBackOfficeComment = value;
			const comment = this.BackOfficeCommentList.find(item => item.id === value);
			if (comment && comment.comment) {
				this.correctionReason += (this.correctionReason ? '\n' : '') + comment.comment;
			}
		},
		handleBlockReasonChange(value) {
			this.selectedBlockReasonId = value;
		},
		async blueUpdateStatus(loan_request) {
			this.loading = true;
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.AdminBluUpdateStatusViewSet + loan_request,
				this.$PATH.SERVICE_NAME.LOYALTY,
				{},
			);
			if (res.status === 428) {
				this.getData();
				this.loading = false;
			}
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'اطلاعات با موفقیت بروزرسانی شد',
				});
				this.getData();
				this.loading = false;
			}
		},
		openBlockUserModal(item) {
			this.selectedBlockItem = item;
			this.selectedBlockReasonId = '';
			this.selectedID = item.id;
			this.blockUserModal = true;
		},
		async confirmBlockUser() {
			const reasonText = 'لغو وام به درخواست کاربر';
			if (!this.selectedBlockItem || !this.selectedBlockItem.loan_cases || !this.selectedBlockItem.loan_cases[0]) {
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'اطلاعات پرونده نامعتبر است',
				});
				return;
			}
			const payload = {
				need_to_correct_fields: [],
				reason: reasonText,
				state: 'blocked',
			};
			try {
				const res = await this.$ApiServiceLayer.patch(
					this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS +
					this.selectedBlockItem.loan_cases[0].loan_request +
					'/',
					this.$PATH.SERVICE_NAME.LOYALTY,
					payload,
				);
				if (res.status === 200) {
					this.$notify({
						group: 'tc',
						type: 'success',
						text: 'مسدودسازی با موفقیت ثبت شد',
					});
					this.blockUserModal = false;
					this.getData();
				} else {
					this.$notify({
						group: 'tc',
						type: 'error',
						text: 'خطا در ثبت مسدودسازی',
					});
				}
			} catch (e) {
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'خطا در ثبت مسدودسازی',
				});
			}
		},
		handleTextChange(value) {
			this.computedMobileNumber = value;
		},
		handleCodeChange(value) {
			this.computedNationalCode = value;
		},

		handleJobSelectChange(value) {
			this.selectedJobOption = value;
		},
		handleStateChange(value) {
			this.selectedState = value;
		},
		moreInfoHandler(item) {
			this.selectedLoanCase = item.loan_cases[0];
			this.selectedGBUser = item.gb_user;
			this.moreInfoModal = !this.moreInfoModal;
			this.selectedID = item.id;
		},
		storeHandler(item) {
			this.storeOwnerName = item.store_owner_name;
			this.storeMobileNumber = item.store_phone_number;
			this.storeModal = true;
		},
		removeFilter() {
			this.computedMobileNumber = '';
			this.computedNationalCode = '';
			this.selectedCaseStatusOption = '';
			this.selectedJobOption = '';
			this.rangeDate = ['', ''];
			// this.$refs.mobileInput.$emit('textChange', '');
			this.getData();
		},
		async editUserInfo() {
			this.loading = true;
			const userData = {
				first_name: this.formData.gbUser.first_name,
				last_name: this.formData.gbUser.last_name,
				national_code: this.formData.gbUser.national_code,
				// birth_date: this.formData.gbUser.birth_date_fa,
				job: this.formData.gbUser.job,
				job_role: this.formData.gbUser.job_role,
				postal_code: this.formData.gbUser.postal_code,
				house_ownership: this.formData.gbUser.house_ownership,
				income_avg: this.formData.gbUser.income_avg,
				cost_avg: this.formData.gbUser.cost_avg,
				monthly_instalment: this.formData.gbUser.monthly_instalment,
				// city: this.formData.gbUser.city,

				family1_first_name: this.formData.loanCase.family1_first_name,
				family1_last_name: this.formData.loanCase.family1_last_name,
				family1_relation: this.formData.loanCase.family1_relation,
				family1_national_code: this.formData.loanCase.family1_national_code,
				family1_phone_number: this.formData.loanCase.family1_phone_number,
				family2_first_name: this.formData.loanCase.family2_first_name,
				family2_last_name: this.formData.loanCase.family2_last_name,
				family2_relation: this.formData.loanCase.family2_relation,
				family2_national_code: this.formData.loanCase.family2_national_code,
				family2_phone_number: this.formData.loanCase.family2_phone_number,
			};

			if (this.changedFiles.income_account_print) {
				userData.income_account_print_link = this.uploadedFiles.income_account_print.link;
				userData.income_account_print_uuid = this.uploadedFiles.income_account_print.uuid;
			}

			if (this.changedFiles.income_cheque) {
				userData.income_cheque_link = this.uploadedFiles.income_cheque.link;
				userData.income_cheque_uuid = this.uploadedFiles.income_cheque.uuid;
			}

			if (this.changedFiles.occupation_proof) {
				userData.occupation_proof_link = this.uploadedFiles.occupation_proof.link;
				userData.occupation_proof_uuid = this.uploadedFiles.occupation_proof.uuid;
			}

			try {
				const res = await this.$ApiServiceLayer.patch(
					`${this.$PATH.RELATIVE_PATH.MULTI.ADMIN_LOAN_CASE_UPDATE}${this.selectedID}/`,
					this.$PATH.SERVICE_NAME.LOYALTY,
					userData,
				);

				if (res.status === 200) {
					this.$notify({
						group: 'tc',
						type: 'success',
						text: 'اطلاعات با موفقیت بروزرسانی شد',
					});

					this.changedFiles = {
						income_account_print: false,
						income_cheque: false,
						occupation_proof: false,
					};

					this.moreInfoModal = false;
					this.getData();
					this.loading = false;
				}
			} catch (error) {
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'خطا در بروزرسانی اطلاعات',
				});
				console.error('Error updating data:', error);
			}
		},
		async acceptLoan() {
			this.acceptLoanLoading = true;

			const res = await this.$ApiServiceLayer.patch(
				`${this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS}${this.selectedLoanCase.loan_request}/`,
				this.$PATH.SERVICE_NAME.LOYALTY,
				{ state: 'admin_confirmed' },
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تایید با موفقیت ثبت شد',
				});
				this.moreInfoModal = false;
				this.getData();
			}
			this.acceptLoanLoading = false;
		},
		editLoan() {
			this.moreInfoModal = !this.moreInfoModal;
			this.editLoanModal = !this.editLoanModal;
		},
		rejectLoan() {
			this.moreInfoModal = !this.moreInfoModal;
		},

		async submitCorrections() {
			this.submitEditloading = true;
			// if (this.selectedFields.length === 0) {
			// 	this.$notify({
			// 		group: 'tc',
			// 		type: 'warning',
			// 		text: 'لطفا حداقل یک فیلد را انتخاب کنید',
			// 	});
			// 	return;
			// }

			const payload = {
				// loan_case_id: this.selectedLoanCase.id,
				need_to_correct_fields: this.selectedFields,
				reason: this.correctionReason,
				state: this.selectedState,
			};

			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS +
				this.selectedLoanCase.loan_request +
				'/',
				this.$PATH.SERVICE_NAME.LOYALTY,
				payload,
			);

			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'درخواست اصلاح با موفقیت ثبت شد',
				});
				this.editLoanModal = false;
				this.selectedFields = [];
				this.correctionReason = '';
			}
			this.submitEditloading = false;
		},
		async myCallback() {
			await this.getData(20, 20 * (this.page - 1));
		},
		cancelEdit() {
			this.editLoanModal = false;
			this.selectedFields = [];
			this.correctionReason = '';
		},
		updateGBUser(field, value) {
			if (this.selectedGBUser) {
				this.selectedGBUser[field] = value;
			}
		},
		updateLoanCase(field, value) {
			if (this.selectedLoanCase) {
				this.selectedLoanCase[field] = value;
			}
		},
		uploadFile(type) {
			const fileInput = document.createElement('input');
			fileInput.type = 'file';
			fileInput.accept = 'image/*, application/pdf';

			fileInput.onchange = (event) => {
				const file = event.target.files[0];
				if (file) {
					console.log('Selected file:', file);
					this.handleFileUpload(file, type);
				} else {
					console.error('No file selected');
				}
			};

			fileInput.click();
		},

		async handleFileUpload(file, type) {
			if (!file) {
				console.error('File is empty');
				return;
			}

			try {
				this.loading = true;
				const formData = new FormData();
				formData.append(type, file);
				// formData.append('file_type', type);

				console.log('FormData created with file:', file.name, file.size);

				const response = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.MULTI.LOAN_CASE_DOCUMENT_UPLOAD + this.selectedID + '/',
					this.$PATH.SERVICE_NAME.LOYALTY,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					},
				);

				if (response.status === 201 || response.status === 200) {
					this.changedFiles[type] = true;

					this.uploadedFiles[type] = {
						link: response.data.arvan_url,
						uuid: response.data.uuid,
					};
					console.log(this.uploadedFiles);
					this.$notify({
						group: 'tc',
						type: 'success',
						text: ' فایل با موفقیت بارگذاری شد، جهت بروزرسانی پرونده پس از اعمال سایر تغییرات مد نظرتان، حتما دکمه "ذخیره تغییرات" را بزنید',
					});
				}
			} catch (error) {
				console.error('Upload failed:', error);
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'خطا در بارگذاری فایل',
				});
			}
			this.loading = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.empty-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 80vh;
}

.action-list {
	width: 100%;
	padding: 24px;
	min-height: 80vh;

	.filter-box {
		box-shadow: 0px 0px 10px 0px rgba(214, 214, 214, 0.6);
		padding: 24px;
		border-radius: 8px;

		.inputs-container {
			display: flex;
		}

		.date-filter {
			margin-bottom: 15px;
			margin-right: 8px;

			label {
				display: block;
				margin-bottom: 5px;
			}

			.inputs {
				width: 200px;
				height: 38px;
				border: 1px solid #c4c4c4;
				padding: 0 9px;
				border-radius: 4px;
			}
		}
	}

	.box {
		margin-top: 16px;
		padding: 24px;
		border-radius: 2px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 0px 10px 0px rgba(214, 214, 214, 0.6);
	}

	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}

	.watch-items {
		cursor: pointer;
	}

	.action-icon {
		cursor: pointer;
		width: 32px;
	}
}

.icon-red {
	filter: brightness(0) saturate(100%) invert(25%) sepia(85%) saturate(915%) hue-rotate(346deg) brightness(95%) contrast(95%);
}

.selected-row {
	background: #fff5f2;
}

.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid #c64925;
	border-radius: 4px;
	background: #c64925;
	color: #fff;
	margin-left: 8px;
	min-width: 75px;
}

.reject-item {
	border: 1px solid #c64925;
	background: #fff;
	color: #000;
	width: 75px;
	border-radius: 4px;
	color: #c64925;
	padding: 8px;
	border-radius: 12px;
	margin-right: 8px;
}

.loan-info-form {
	.form-row {
		display: flex;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.form-group {
		padding: 0 15px;
		margin-bottom: 1.5rem;

		label {
			display: block;
			font-weight: bold;
			margin-bottom: 0.5rem;
			color: #666;
			font-size: 0.9rem;
		}

		p {
			margin: 0;
			color: #333;
			font-size: 1rem;
		}
	}

	h6 {
		color: #c64925;
		font-weight: bold;
		border-bottom: 2px solid #eee;
		padding-bottom: 0.5rem;
	}

	.documents-section {
		.document-links {
			.document-card {
				border: 1px solid #eee;
				padding: 1rem;
				border-radius: 8px;
				text-align: center;
				transition: all 0.3s ease;
				margin-bottom: 16px;

				&:hover {
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				}

				.doc-icon {
					width: 40px;
					height: 40px;
					margin-bottom: 0.5rem;
				}

				.doc-link {
					display: block;
					color: #c64925;
					text-decoration: none;
					font-weight: 500;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
}

// Add this if you want to make the modal wider
::v-deep .modal-xl {
	max-width: 1140px;
}

.edit-form {
	.form-group {
		margin-bottom: 1rem;

		label {
			margin-bottom: 0;
			margin-right: 0.5rem;
		}

		input[type='checkbox'] {
			width: 18px;
			height: 18px;
			cursor: pointer;
		}
	}
}

input {
	width: 200px;
	height: 38px;
	border: 1px solid #c4c4c4;
	padding: 0 9px;
	border-radius: 4px;
	width: 100%;
}
.store-link {
	color: #c64925;
	cursor: pointer;
	text-decoration: underline;
}
</style>
<style>
.VuePagination__count {
	display: none;
}

.page-item.active .page-link {
	background-color: #c64925;
	border-radius: 4px;
}

.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}

.vpd-icon-btn {
	display: none !important;
}

.vpd-input-group input {
	border: none !important;
	border-radius: 0;
}

.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}

/* Add these styles for RTL editor */
.rtl-editor .ql-editor {
	direction: rtl;
	text-align: right;
}

.rtl-editor .ql-container.ql-snow {
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
}

.rtl-editor .ql-toolbar.ql-snow {
	border: 1px solid #ced4da;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
}
</style>
